<template>
  <div v-for="(leg, index) in hotels.route" :key="index">
    <div class="item">
      <div class="line title">
        <span>{{ getDateFlightfox(leg.ideal.checkin) }} &middot; {{ getDurationAccommodationNights(leg.ideal.checkin, leg.ideal.checkout) }}</span>
        <a v-if="isEdit" @click="emit('edit', index)">Edit Hotel</a>
      </div>
      <div class="hotel">
        <img v-if="hotels.route[hotels.route.length - 1].ideal.image_primary != ''" class="col1" :src="leg.ideal.image_primary" @error="photoError($event)" />
        <div class="col2">
          <div class="name">
            {{ leg.ideal.name }}
          </div>
          <div class="place">
            {{ leg.ideal.address_city }}
          </div>
          <div class="room">
            {{ leg.ideal.room_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DateTime from "../utils/datetime.js";

const emit = defineEmits(["edit"]);
defineProps(["isEdit", "hotels"]);

const { getDateFlightfox, getDurationAccommodationNights } = DateTime();

const photoError = event => {
  event.target.style.display = "none";
};
</script>

<style lang="less">
#new {
  .summary {
    .hotel {
      img {
        display: none;

        &.none {
          opacity: 0;
        }
      }

      .col1 {
        padding-right: 2rem;
      }

      .col2 {
        flex: 1;
      }

      .place {
        color: @mid;
        margin-bottom: 1rem;
      }
    }
  }
}

@media screen and (min-width: 60em) {
  #new {
    .summary {
      .hotel {
        display: flex;

        img {
          display: block;
          height: 7.28125rem;
          object-fit: cover;
          width: 10.9375rem;

          &.none {
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>
